export class CourseDeliveryModeBadge {
  description: string;

  $onInit() {
    this.initialize();
  }
  $onChanges(changes: any) {
    this.initialize();
  }
  private initialize() {
    this.description = this.description || '';
  }
}

angular.module('capability-ng-scheduler').component('courseDeliveryModeBadge', {
  templateUrl:
    'capability-ng-scheduler/src/views/components/course_delivery_mode_badge/course_delivery_mode_badge.html',
  bindings: {
    modeName: '@',
    description: '@',
    iconClass: '@'
  },
  controller: CourseDeliveryModeBadge
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/components/course_delivery_mode_badge/course_delivery_mode_badge.ts